import { pairingRequesterSlice } from "./reducer";

export const {
  pairingFailed,
  pairingRequested,
  receivedRequestData,
  receivedResponse,
  resetState
} = pairingRequesterSlice.actions;
